import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detail-bill-payment-modal',
  templateUrl: './detail-bill-payment-modal.component.html',
  styleUrls: ['./detail-bill-payment-modal.component.css']
})
export class DetailBillPaymentModalComponent implements OnInit {
  formData : any = {};
  constructor() { }

  ngOnInit() {
  }

}
